var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16602 6.04173L8.07435 9.72294C8.91882 10.3563 10.0799 10.3563 10.9243 9.72294L15.8327 6.04169",
    stroke: "#355E3B",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 4.45825H3.95833C3.08388 4.45825 2.375 5.16713 2.375 6.04159V13.9583C2.375 14.8327 3.08388 15.5416 3.95833 15.5416H15.0417C15.9161 15.5416 16.625 14.8327 16.625 13.9583V6.04159C16.625 5.16713 15.9161 4.45825 15.0417 4.45825Z",
    stroke: "#355E3B",
    strokeWidth: 0.791667,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5502252ab8c7b149bfa6b79a63067efe.svg";
export { ForwardRef as ReactComponent };